import React from 'react';
import AboutHero from '../components/common/AboutHero';
import Recete3 from '../assets/images/recete3.jpg';
import ContactStrip from '../components/common/ContactStrip';
import CompanionVisitor from '../components/layout/ziyaretci/CompanionVisitor';
import VisitList, { VisitItem } from '../components/layout/ziyaretci/VisitList';
import { toUrl } from '../lib/config';




const HastaneRefakatciPage: React.FC = () => {
    const DEFAULT_HERO = {
      kicker: 'Ziyaret',
      title: 'Refakatçi & Ziyaretçi',
      description: 'Hastalarımız sizin emanetlerinizdir. Hastalarımızın tedavi sürecinin hem refakatçilerimizle hem de ziyaretçilerimizle, profesyonel ekibimizin belirlediği kurallara uyarak daha sağlıklı ilerlemesine dikkat özen gösterilmelidir.'
    };
    const [heroKicker, setHeroKicker] = React.useState<string>('');
    const [heroTitle, setHeroTitle] = React.useState<string>('');
    const [heroDesc, setHeroDesc] = React.useState<string>('');
    const [heroLoading, setHeroLoading] = React.useState<boolean>(true);

    React.useEffect(() => {
      let cancelled = false;
      const run = async () => {
        try {
          setHeroLoading(true);
          const res = await fetch(toUrl('/api/page-hero/refakatci-ziyaretci'));
          if (!res.ok) throw new Error('fetch_failed');
          const data = await res.json();
          const obj = Array.isArray(data) ? (data[0] || {}) : (data || {});
          if (!cancelled) {
            setHeroKicker((obj.kicker || '').trim());
            setHeroTitle((obj.title || '').trim());
            setHeroDesc((obj.description || '').trim());
          }
        } catch {
          // ignore
        } finally {
          if (!cancelled) setHeroLoading(false);
        }
      };
      run();
      return () => {
        cancelled = true;
      };
    }, []);




  const DEFAULT_VISIT_ITEMS: VisitItem[] = [
    {
      id: "megapark",
      titleLight: "Hastanemizi",
      titleAccent: "Ziyaret Edin",
      description:
        "Hastanemizi ziyaret ederek bütün sağlık hizmetlerinden profesyonel kadromuzla faydalanın.",
      accentColor: "#2cadd2",
      mapSrc:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.3583965308617!2d36.9591286!3d37.5701775!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x152de786eb8c813f%3A0xae5e14dbc0c189d6!2s%C3%96zel%20MegaPark%20Hastanesi!5e0!3m2!1str!2str!4v1759780781173!5m2!1str!2str" // kendi embed URL'inizi koyun


    },
  ];
  const [visitItems, setVisitItems] = React.useState<VisitItem[]>(DEFAULT_VISIT_ITEMS);

  React.useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        const res = await fetch(toUrl('/api/visit-items'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        const list = Array.isArray(data) ? data : [];
        const mapped: VisitItem[] = list
          .slice()
          .sort((a: any, b: any) => (a.orderIndex ?? 0) - (b.orderIndex ?? 0))
          .map((it: any) => ({
            id: (it.slug || it.id || '').toString(),
            titleLight: it.titleLight || '',
            titleAccent: it.titleAccent || '',
            description: it.description || '',
            mapSrc: it.mapSrc || '',
            accentColor: '#2cadd2',
          }));
        if (!cancelled && mapped.length) setVisitItems(mapped);
      } catch {
        // keep defaults
      }
    };
    run();
    return () => { cancelled = true; };
  }, []);
  // Defaults (API hata verirse kullanılacak)
  const DEFAULT_COMPANION = {
    title: "Refakatçi",
    paragraphs: [
      "Tedavi sırasında hastaya yardımcı olmak üzere; mevzuatın ve hastanemizin imkanlarının elverdiği ve hastanın sağlık durumunun gerektirdiği ölçüde, tedaviden sorumlu doktorun uygun görmesine bağlı olarak, hastanın refakatçi bulundurma hakkı vardır. Bu hakkın nasıl ve ne zaman kullanılacağı hastanemizde belirlenen usul ve esaslara uygun olarak gerçekleştirilmelidir. Hastanızın sağlığı açısından bu konuda bize yardımcı olmanızı ve hastanemizin refakatçi politikası çerçevesinde belirlenen usul ve esaslara uygun şekilde hastanıza refakat etmeniz gerektiğini önemle belirtmek isteriz.",
    ],
    list: [
      "Refakatçi sayısı bir kişiyle sınırlıdır.",
      "Refakatçi vizite ve tıbbi bakım sırasında hastanın yanında bulunmamalıdır.",
      "Hekim ve hemşire direktifleri dışında hastaya yönelik herhangi bir uygulama yapmamalıdır. Refakatçi, hastanın bakımına izin verilen ölçüde yardım eder.",
      "İlgili hekim ya da hemşire istemi dışında, hastayı hastane dışına çıkarmamalı veya yatağını değiştirmemelidir.",
      "Sizlere huzurlu bir ortam sağlanması için, refakatçilerin; hasta odası ve servis koridorlarında yüksek sesle konuşmaması, gürültü yapmaması, odalarda bulunan televizyonları başkalarını rahatsız etmeyecek şekilde kullanması; doktor vizite saatlerinde ve saat 22.00’den sonra telefonlarını kapatmaları veya sesini kısık tona ayarlamaları önemlidir.",
      "Hastane içerisinde tütün ve alkol kullanımı yasalar ve hastane kurallarına göre yasaktır.",
      "Refakatçilerin hastane dışından yiyecek ve içecek getirmemesi, diyetisyen kontrolü olmayan hiçbir yiyeceğin hastaya verilmemesi gerekmektedir.",
      "Refekatçi değişiminde mutlaka hemşiresine bilgi verilmesi gerekmektedir.",
      "Refakatçi genel hastane kurallarına uymakla yükümlüdür. İhlali halinde, hastanıza refakat durumunuz kabul edilmeyecektir.",
      "Tüm bunların dışında refakatçi olarak, hastanın sağlığı açısından herhangi bir sorun olduğu zaman öncelikle servis hemşirelerine bilgi vermelidir. Servis hemşirelerinin bilgisi dışından herhangi bir müdahalede bulunmamalıdır.",
    ],
  };
  const DEFAULT_VISITOR = {
    title: "Ziyaretçi",
    paragraphs: [] as string[],
    list: [
      "Hasta ziyareti kısa tutulmalıdır.",
      "10 yaşından küçüklerin ziyareti bulaşıcı hastalık riski taşımaktadır.",
      "Ziyaret sınırlaması konulan hastaları ziyaret etmek için ısrar edilmemelidir.",
      "Hasta odasına 3 kişiden fazla ziyaretçi girmemelidir.",
      "Hasta ziyaretine yiyecek içecek getirilmemelidir.",
      "Hasta odasında sigara vb. içilmemelidir.",
      "Hasta odasının penceresi açılmamalıdır.",
      "Ziyaret konusunda görevlilerin talimatlarına uyulmalıdır.",
      "Saat 10:00-22:00 saatleri dışında ziyaret yapılmamalıdır.",
    ],
  };

  const [companion, setCompanion] = React.useState(DEFAULT_COMPANION);
  const [visitor, setVisitor] = React.useState(DEFAULT_VISITOR);

  React.useEffect(() => {
    let cancelled = false;
    const fetchBoth = async () => {
      try {
        const [cRes, vRes] = await Promise.all([
          fetch(toUrl('/api/companion')),
          fetch(toUrl('/api/visitor')),
        ]);
        if (!cRes.ok || !vRes.ok) throw new Error('fetch_failed');
        const [cData, vData] = await Promise.all([cRes.json(), vRes.json()]);
        if (cancelled) return;
        const cObj = Array.isArray(cData) ? (cData[0] || {}) : (cData || {});
        const vObj = Array.isArray(vData) ? (vData[0] || {}) : (vData || {});

        const mapLines = (arr: any[]): string[] =>
          (Array.isArray(arr) ? arr : [])
            .slice()
            .sort((a: any, b: any) => (a.orderIndex ?? 0) - (b.orderIndex ?? 0))
            .map((x: any) => (x?.text || '').trim())
            .filter((s: string) => !!s);

        setCompanion({
          title: (cObj.title || DEFAULT_COMPANION.title).trim(),
          paragraphs: mapLines(cObj.paragraphs),
          list: mapLines(cObj.list),
        });
        setVisitor({
          title: (vObj.title || DEFAULT_VISITOR.title).trim(),
          paragraphs: mapLines(vObj.paragraphs),
          list: mapLines(vObj.list),
        });
      } catch {
        // defaults kalır
      }
    };
    fetchBoth();
    return () => { cancelled = true; };
  }, []);
  return (
    <>
      {/* <AboutHero
        image={Recete3}
        kicker="Ziyaret"
        title="Refakatçi & Ziyaretçi"
        description="Hastalarımız sizin emanetlerinizdir. Hastalarımızın tedavi sürecinin hem refakatçilerimizle hem de ziyaretçilerimizle, profesyonel ekibimizin belirlediği kurallara uyarak daha sağlıklı ilerlemesine dikkat özen gösterilmelidir."
        overlayColor="#2cadd2"
        overlayOpacity={0.72}
        accentColor="#e30613"
        textColor="#2b2b2b"
        focus="center center"
        align="center"
        desktopHeight={460}
        tabletHeight={380}
        mobileHeight={320}
      /> */}

        <AboutHero
        image={Recete3}
        kicker={heroKicker || DEFAULT_HERO.kicker}
        title={heroTitle || DEFAULT_HERO.title}
        description={heroDesc || DEFAULT_HERO.description}
        overlayColor="#2cadd2"
        overlayOpacity={0.72}
        accentColor="#e30613"
        textColor="#2b2b2b"
        focus="center center"
        align="center"
        desktopHeight={460}
        tabletHeight={380}
        mobileHeight={320}
      />

      <CompanionVisitor
        accentColor="#2ba87a
"
        companion={companion}
        visitor={visitor}
      />

      <VisitList items={visitItems} defaultAccent="#2cadd2" />

      <ContactStrip />

    </>
  );
};

export default HastaneRefakatciPage;
